import { render, staticRenderFns } from "./RecognitionDashboard.vue?vue&type=template&id=68ee9fb2&scoped=true&"
import script from "./RecognitionDashboard.vue?vue&type=script&lang=js&"
export * from "./RecognitionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionDashboard.vue?vue&type=style&index=0&id=68ee9fb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee9fb2",
  null
  
)

export default component.exports